import { COLORS } from '../utils/colors';
import { siteContent } from '../content';
import { Card, Section } from './Card';

export const Approach = ({ isVisible }) => (
  <Section
    id="approach"
    alt
    isVisible={isVisible}
    title={<>The <span style={{ color: COLORS.cantaloupe }}>rockmelon</span> Approach</>}
    subtitle={siteContent.approach.subtitle}
  >
    <div className="grid md:grid-cols-3 gap-8">
      {siteContent.approach.phases.map((phase) => (
        <Card key={phase.title} className="text-center">
          <div className="text-4xl mb-4">{phase.icon}</div>
          <h3 className="text-2xl font-bold mb-4" style={{ color: COLORS.navy }}>{phase.title}</h3>
          <p className="mb-6" style={{ color: COLORS.slate }}>{phase.description}</p>
          <div className="font-semibold" style={{ color: COLORS.teal }}>{phase.metric}</div>
        </Card>
      ))}
    </div>

    <Card className="mt-16 p-4">
      <img
        src={siteContent.approach.backgroundImage}
        alt="Technology Infrastructure Visualization"
        className="w-full h-64 object-cover rounded-xl"
      />
    </Card>
  </Section>
);
